/*
*   主图预览组件
*   zxw
*   2024-08-21
*/

import React , { useState, useEffect } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import { message,
    Modal, 
    Image,Tooltip,} from 'antd';
import { UjoinParams, AddRequestHeaders, 
    AliyunOSSclient} from '../../incs/FunHelper.js';

import LOGO1 from '../../images/logo_location_1.png';
import LOGO2 from '../../images/logo_location_2.png';

/**
 * 根据logo编码，返回对应的logo图片
 * @param {*} number 
 * @returns 
 */
const getLogoImage = (number) => {
    switch(number){
        case 1:
            return LOGO1;
        case 2:
            return LOGO2;
        default:
            return null;
    }
}

const MainImagePreview = (props) => {
    const [open, setOpen] = useState(false);
    const [attachImageUlid, setAttachImageUlid] = useState(''); //  附加图ulid
    const [logoImages, setLogoImages] = useState([]); 
    const [mianImage, setMainImage] = useState('');             //  底层主图
    // const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');       //  预览附图
    const [path,setPath] = useState('');

    useEffect(() => {
        setOpen(props.open);
        // setMainUlid(props.record.key);
        const params = {
            'main_ulid': props.record.key,
            'page_size': CNF.pageSize * 10,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}intersection/images${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        let logoImages = [];
                        //  获取主图logo图片
                        for(let i=0; i<data.dat.length; i++){
                            let item = data.dat[i];
                            if(props.record.key === item.main_ulid){
                                //  获取主图的logo图片
                                logoImages.push({
                                    key: item.key,
                                    path: item.path,
                                    name: item.name,
                                    is_main: item.is_main,
                                    x: item.x,
                                    y: item.y,
                                    logo_number: item.logo_number,
                                    rotation_angle:  item.rotation_angle,
                                });
                            }
                        }
                        setLogoImages(logoImages);

                    }else{
                        setLogoImages([]);
                    }
                    
                }else{
                    message.error(data.msg, 1.5);
                }
            }
        })
    }, [props])

    /**
     * 从阿里云下载
     * @param {*} file
     */
    const aliyunOSSDownload = (file) =>{
        var params = {
            'oss': 'GetObject'
        }
        $.ajax({
            url: CNF.api + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    const token = data.dat;
                    try {
                        //  去掉路径‘/’
                        let result = AliyunOSSclient(token).signatureUrl(file.path, {
                            expires: 3600,
                            response: {
                                'content-disposition': 'attachment; filename="' + file.name + '"'
                            }
                        });
                        if(file.is_main){
                            setMainImage(result);
                        }else{
                            setPreviewImage(result);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }else{
                    message.error(data.msg, 1);
                }
            }
        });
    }

    useEffect(() => {
        if(props.record.path !== path){
            aliyunOSSDownload({
                name: props.record.name,
                path: props.record.path,
                is_main: props.record.is_main,
            });
            setPath(props.record.path);
        }
        
    }, [props,path]);


 
    return (
        <Modal
            width={600}
            style={{ top: 0,padding: 0,}}
            // title={props.record.name}
            closable={false}
            open={open}
            keyboard={true}
            maskClosable={true}
            onCancel={()=>{setOpen(false);}}
            footer={null}
        >
            <div style={{
                width: 600,
                position: 'relative',
                borderRadius: 8,
                top: 0,
                margin: '-20px -24px',
            }}>
                <Image style={{ borderRadius: 8, }} src={mianImage} preview={false}/>
                {
                    logoImages && logoImages.map((item, index)=>{
                        return <Tooltip 
                            key={index}
                            color='#FF904D' 
                            style={{ padding:0,}}
                            title={<div style={{
                                    width: 250,
                                    height: 250,
                                    // padding: '-6px -8px',
                                    margin: '-6px -8px',
                                    borderRadius: 6,
                                    border: 0,
                                }}><Image style={{borderRadius: 6,border: 0,}} src={previewImage} width={250} height={250}/></div>}>
                            <div style={{
                                position: 'absolute',
                                top: item.y,
                                left: item.x,
                                width: 40,
                                height: 60,
                                transform: 'rotate(' + item.rotation_angle + 'deg)',
                                cursor: 'pointer',
                            }}
                                onMouseEnter={()=>{
                                    if(!attachImageUlid || attachImageUlid !== item.key){
                                        setAttachImageUlid(item.key);
                                        aliyunOSSDownload(item);
                                    }
                                }}
                            >
                                <Image width={40} height={60} preview={false} src={getLogoImage(item.logo_number)}/>
                            </div>
                        </Tooltip>
                    })
                }
            </div>
        </Modal>
    );
};

export default MainImagePreview;